'use client'
import React from 'react'
import './global-footer.css'
import { useConfig } from '@/contexts/config-context';


export default function GlobalFooter() {
    const config = useConfig();

    if (!config || !config?.footer_image || !config?.footer_text) {
        return <></>;
    }

    return (
        <footer className="global-footer" style={{ backgroundColor: config?.footer_background_color, color: config?.footer_text_color, paddingTop: '30px', bottom: '0', width: '100%' }} >
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginLeft: '10px', marginRight: '10px' }}>
                {
                    config?.footer_image && (
                        <img style={{ width: '100%', maxWidth: '400px', objectFit: 'contain', marginBottom: '20px' }} src={config?.footer_image} alt="Logo" />
                    )
                }
            </div>
            {
                config?.footer_text && (
                    <div className="footer-content"
                        style={{ fontSize: 8, textAlign: 'justify', marginTop: '20px', textJustify: 'auto', maxWidth: '600px', margin: '0 auto' }}
                        dangerouslySetInnerHTML={{ __html: config?.footer_text }}
                    />
                )
            }

        </footer>
    )
}
